import React, { Component } from 'react';
import md5 from 'md5';
import Prompt from 'components/Prompt';
import Select from 'components/Select';
import { Wrap, Title } from './PresetSwitcher.styled';
import presets, { getPreset, getDefaultPreset } from 'config/presets';

const LAST_USED_PRESET_KEY = 'last_used_preset';

export const initialPreset = (() => {
  const lastUsed = localStorage.getItem(LAST_USED_PRESET_KEY);
  if (lastUsed) {
    const preset = getPreset(lastUsed);

    if (preset) {
      if (preset.password) {
        const password = localStorage.getItem(`p-${preset.name}`);
        if (password === preset.password) {
          return preset;
        }
      } else {
        return preset;
      }
    }
  }

  return getDefaultPreset();
})();

const getItems = () => presets.map(p => ({ value: p.name, label: p.name }));

type Props = {
  onChange: any,
};

class PresetSwitcher extends Component<Props> {
  state = {
    currentPreset: initialPreset.name,
    shouldPrompt: false,
  };

  handleChangeInternal = (preset, askPassword = true) => {
    let canChange = false;

    if (preset.password) {
      const password = localStorage.getItem(`p-${preset.name}`);
      if (password === preset.password) {
        // We have access!
        canChange = true;
      } else if (askPassword) {
        this.presetTemporary = preset;
        this.setState({ shouldPrompt: true });
      }
    } else {
      canChange = true;
    }

    if (canChange) {
      this.props.onChange(preset);
      this.setState({ currentPreset: preset.name });
      localStorage.setItem(LAST_USED_PRESET_KEY, preset.name);
    }
  };

  handleChange = e => {
    const preset = getPreset(e.target.value);
    this.handleChangeInternal(preset);
  };

  handlePrompt = password => {
    this.setState({ shouldPrompt: false });

    if (!this.presetTemporary || !this.presetTemporary.password || !password)
      return;

    localStorage.setItem(`p-${this.presetTemporary.name}`, md5(password));
    this.handleChangeInternal(this.presetTemporary, false);
  };

  render() {
    const { currentPreset, shouldPrompt } = this.state;
    return (
      <Wrap>
        <Title>PRESET</Title>
        {shouldPrompt && (
          <Prompt message="Enter magic password" onSubmit={this.handlePrompt} />
        )}
        <Select
          value={currentPreset}
          onChange={this.handleChange}
          items={getItems()}
        />
      </Wrap>
    );
  }
}

export default PresetSwitcher;



// WEBPACK FOOTER //
// /opt/build/repo/src/modules/main/components/PresetSwitcher/PresetSwitcher.js